// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"ou_a bhv_a bhv_x","FilterForm__vgroup":"ou_b bhv_rp"};